(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('type-contrat', {
            parent: 'entity',
            url: '/type-contrat?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'wamasysApp.contractType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/type-contrat/type-contrats.html',
                    controller: 'ContractTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('contractType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('type-contrat-detail', {
            parent: 'entity',
            url: '/type-contrat/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.contractType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/type-contrat/type-contrat-detail.html',
                    controller: 'ContractTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('contractType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ContractType', function($stateParams, ContractType) {
                    return ContractType.get({id : $stateParams.id});
                }]
            }
        })
        .state('type-contrat.new', {
            parent: 'type-contrat',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-contrat/type-contrat-dialog.html',
                    controller: 'ContractTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                label: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('type-contrat', null, { reload: true });
                }, function() {
                    $state.go('type-contrat');
                });
            }]
        })
        .state('type-contrat.edit', {
            parent: 'type-contrat',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-contrat/type-contrat-dialog.html',
                    controller: 'ContractTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ContractType', function(ContractType) {
                            return ContractType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('type-contrat', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('type-contrat.delete', {
            parent: 'type-contrat',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-contrat/type-contrat-delete-dialog.html',
                    controller: 'ContractTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ContractType', function(ContractType) {
                            return ContractType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('type-contrat', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
